import mutate from 'js-core/js/apollo/mutations/mutate';

import UpdateTreatmentMutation from 'gql/mutations/Treatment/UpdateTreatment.gql';
import DeleteTreatmentMutation from 'gql/mutations/Treatment/DeleteTreatment.gql';

export default class{

    static update(input) {

        return mutate(UpdateTreatmentMutation, { input });
    }

    static delete(id) {

        return mutate(DeleteTreatmentMutation, { id });
    }
}
